import React from 'react'

type UseSavedValueOptions<T> = {
  key: string
  defaultValue: string
  loadTransform?: (parsed: T) => T
  useSession?: boolean
}

const useSavedValue = <T>({
  key,
  defaultValue,
  loadTransform = v => v,
  useSession = false
}: UseSavedValueOptions<T>) => {
  const storage = React.useMemo(
    () => (useSession ? sessionStorage : localStorage),
    [useSession]
  )

  // Load value from storage or use a default when not saved
  // Also apply any transform function on the parsed data
  const [value, setValue] = React.useState<T>(
    loadTransform(JSON.parse(storage.getItem(key) ?? defaultValue))
  )

  // Save value on change
  React.useEffect(() => {
    storage.setItem(key, JSON.stringify(value))
  }, [storage, key, value])

  return [value, setValue] as [T, React.Dispatch<React.SetStateAction<T>>]
}

export default useSavedValue
